'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'bars-sort';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e0ae';
var svgPathData = 'M0 88C0 74.75 10.75 64 24 64H424C437.3 64 448 74.75 448 88C448 101.3 437.3 112 424 112H24C10.75 112 0 101.3 0 88zM0 248C0 234.7 10.75 224 24 224H296C309.3 224 320 234.7 320 248C320 261.3 309.3 272 296 272H24C10.75 272 0 261.3 0 248zM168 432H24C10.75 432 0 421.3 0 408C0 394.7 10.75 384 24 384H168C181.3 384 192 394.7 192 408C192 421.3 181.3 432 168 432z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBarsSort = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;